import React from 'react';
import { useParams } from 'react-router-dom';
import { FTUWizard } from './index';
import { useFTUWizardContext } from './context/ftu-wizard-context';

/**
 * Route-based component for the FTU Wizard
 * Uses the consolidated context for all FTU wizard functionality
 * @returns {React.ReactElement} The FTU Wizard component
 */
export const FTUWizardRoute = () => {
  const { step } = useParams();
  const { getStepKey, handleClose } = useFTUWizardContext();

  return <FTUWizard initialStep={getStepKey(step)} onClose={handleClose} />;
};
